export const SYNC_REGION = 'SYNC_REGION';
